import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Grid from '@mui/material/Grid';
import { useMsal } from "@azure/msal-react";

import Header from './Header';
import Footer from './Footer';
import SideMenu from './SideMenu';
import idleTimer  from '../components/Helper/idleTimer';
import * as userActions from '../store/actions/userManagement'
import { connect } from 'react-redux';
import SelfRegistration from '../pages/SignIn/SelfRegistration' ;
import InactiveUser from '../pages/SignIn/InactiveUser';
import { azureLogOut } from "../store/actions/auth";

const Content = styled.div`
 padding: 1rem;

@media (max-width: 1390px) {
    padding: 1rem;
}
@media (max-width: 1200px) {
    padding: 1rem ;
    margin: 0 1rem;
}

`;

const ContentWrapper = styled.div`
background:#FFF;
@media (min-width: 1200px) {
    padding: 0 1rem 0rem 1rem ;
}
@media (min-width: 1420px){
    margin: 0 0 0rem 0rem ;
}
@media (max-width: 1600px){
    padding: 0 0 0rem 0rem ;
}
@media (max-width: 1200px) {
    padding: 0 0 0 0 ;
}
@media (min-width:1200px ) and (max-width: 1400px) {
    padding: 0 0 1rem 2rem ;
}
@media (min-width: 1900px) and (max-width: 2200px){
    margin: 0 0 0 0rem ;
}
@media (min-width: 2200px) and (max-width: 2400px){
    margin: 0 0 0 0rem ;
}
@media (min-width: 2400px) and (max-width: 2600px){
    margin: 0 0 0 0rem ;
}
@media (min-width: 2600px){
    margin: 0 0 0 0rem ;
}
`;

const MainLayout = (props) => {
    const { children, getProfileDetails, userProfile } = props;
    const { instance } = useMsal();

    const [selfRegistrationDialogOpen, setSelfRegistrationDialogOpen] = useState();
    const [inactiveOpen, setInactiveOpen] = useState();
  
    // Retrieve values from localStorage/sessionStorage only once
    const userDetailsLoc = JSON.parse(window.localStorage.getItem("userInfo"));
    const email = userDetailsLoc?.email || window.sessionStorage.getItem("user_name");
    const userName = window.localStorage.getItem("userFullName");
    const tokenDetail = window.localStorage.getItem("tokenDetail");

    useEffect(() => {
        idleTimer(instance);
    }, [instance]);

    useEffect(() => {
        const dataObj = {
            email,
            token: tokenDetail,
            userName,
        };
        getProfileDetails(dataObj, instance);
    }, [getProfileDetails, instance]);


    useEffect(()=>{
        if(userProfile && userProfile?.data && !userProfile?.data?.isProfileExist && !userProfile?.data?.isUserInActive){
            setSelfRegistrationDialogOpen(true);
            setInactiveOpen(false);
        } else if(userProfile && userProfile?.data && userProfile?.data?.isUserInActive && !userProfile?.data?.isProfileExist) {
            setInactiveOpen(true);
            setSelfRegistrationDialogOpen(false);
        } else {
            setSelfRegistrationDialogOpen(false);
            setInactiveOpen(false);
        }
    },[userProfile])

    const handleDialogClose = () => {
        setSelfRegistrationDialogOpen(false);
    };
    const handleInactiveClose = () => {
        setInactiveOpen(false);
    };

    return (
    <ContentWrapper>
        <Grid container>
            {/* <Grid  role="navigation"  item padding={{ left: 0}} display={{ xs: "none", sm: "none", xl:"block", lg:"block", md:"none" }} xl={1.7} lg={2.5}>
                <SideMenu />
            </Grid> */}
          
            <Grid style={{marginTop:"90px"}} item xs={12} sm={12} md={12} xl={12} lg={12} >
                <Header/>
                <div className='content-wrapper'>
                    <Content role="main" style={{marginBottom:"50px", minHeight: '90vh'}}>
                    {selfRegistrationDialogOpen && (
                        <SelfRegistration 
                        openDialog={selfRegistrationDialogOpen}
                        onClose={handleDialogClose}
                        />
                    )}
                    {inactiveOpen && (
                        <InactiveUser 
                        openDialog={inactiveOpen}
                        onClose={handleInactiveClose}
                        azureLogOut={()=>{azureLogOut(instance)}}
                        userProfile={userProfile}
                        />
                    )}
                    {userProfile?.data?.isProfileExist && !userProfile?.data?.isUserInActive && (
                        children
                    )}
                    </Content>
                </div>
                    <Footer/>
            </Grid>
        </Grid>
    </ContentWrapper>
      

    );
}
const mapStateToProps = (state) => ({ 
    userProfile: state.userReducer.userProfile,
})

const mapDispatchToProps = (dispatch) => {
    return {
        getProfileDetails: (dataObj, instance) => dispatch(userActions.getProfileDetails(dataObj, instance)),
    };
};

MainLayout.propTypes = {
    children: PropTypes.node.isRequired
}
export default connect(mapStateToProps, mapDispatchToProps)(MainLayout);
